export default "/images/mic.svg?b386a135fc6f50f1b194adc073216ed7";